<template>
  <div class="order-create__section"
       v-bind:class="{'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}">
    <div class="admin-edit"
         @click="editTranslate(['fbm_ProductConsolidation', 'fbm_ProductConsolidationToltip'])"></div>

    <template v-if="!isWarehouse">
      <div class="order-create__section-label section-label">
        {{$t('fbm_ProductConsolidation.localization_value.value')}}
        <v-popover class="site-tooltip" :disabled="!tooltipAddProductActive" offset="5" placement="top" trigger="hover">
          <TooltipBtn/>
          <template slot="popover">
            <p><b>{{$t('fbm_ProductConsolidation.localization_value.value')}}</b></p>
            <p>{{$t('fbm_ProductConsolidationToltip.localization_value.value')}}</p>
          </template>
        </v-popover>
      </div>


      <div class="mb-2 color-orange-validation" v-if="FBM.validation.ProformProducts">
        {{ $t(`${FBM.validationTranslate.ProformProducts}.localization_value.value`) }}
      </div>
      <template v-for="(item, index) in proformProducts">
        <div class="order-create__title-horizontal"
             :key="index + '1'"
             v-bind:class="{'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}">
          <div class="admin-edit" @click="editTranslate([
						'product_Product',
						'common_DeleteProduct',
					])"></div>
          <TitleHorizontal
                  :value="$t('product_Product.localization_value.value') + ' #' + parseInt(index + 1)"
                  :rightBtn="true"
                  :rightBtnType="'delete'"
                  :rightBtnText="$t('common_DeleteProduct.localization_value.value')"
                  @rightBtnClick="$emit('removeProformProduct', index)"
          />
        </div>

        <ProductItemCreation
                :key="index"
                :product="item"
                :serverError="serverError"
                :visibleHSCode="FBM.data.visibleHSCode"
                :canChangeHSCode="true"
                :altVersion="true"
                :isShowCustomHS="true"
                :userId="FBM.data.User.userId"
                @changeCategory="({val, nameVal}) => $emit('changeCategory', {val, nameVal, item: proformProducts[index]})"
                @changeProformSelectItem="$emit('changeProformSelectItem', item)"
        />
<!--                :extraFieldWeight="isConsolidation && !!(isPolandByUser(FBM.data.User.user) || isUserCreationIsPoland)"-->
      </template>

      <div class="mb-4"
           v-if="isEasyType">
        <MainButton
            class="wfc"
            :value="'+ ' + $t('common_AddProduct.localization_value.value')"
            @click.native="$emit('addProformProduct')"
        />
      </div>

      <div class="order-create__product-btn add-product-btn-wrap"
           v-else
           v-bind:class="{'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}">
        <div class="admin-edit" @click="editTranslate(['common_AddProduct'])"></div>
        <span class="order-create__product-btn-i add-product-btn site-link"
              @click="$emit('addProformProduct')">
          + {{$t('common_AddProduct.localization_value.value')}}
        </span>
      </div>

      <div class="order-create__total mb-3"
           v-bind:class="{'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}">
        <div class="admin-edit" @click="editTranslate(['common_TotalShippingCost',])"></div>
        {{$t('common_TotalShippingCost.localization_value.value')}}
        <span>${{calculatePrice}}</span>
      </div>
    </template>

<!--    v-if="!isLabel && !isConsolidation"-->
    <template
            v-if="!isLabel"
    >
      <div class="order-create__section-label section-label"
           v-bind:class="{'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}">
        <div class="admin-edit" @click="editTranslate(['fbm_ProductWarehouse',])"></div>
        {{$t('fbm_ProductWarehouse.localization_value.value')}}
      </div>

      <template v-if="showProducts">

        <div class="custom-row">
          <div class="custom-col">
            <div class="d-flex">
              <RadioDefault
                  class="white-space-line width-initial mr-3"
                  v-for="(item, index) in warehouses"
                  :key="index"
                  :label="item.name"
                  :name="'warehouse'"
                  :value="FBM.data.Order.data.warehouse && item.id === FBM.data.Order.data.warehouse.id"
                  @input="changeWarehouse(item)"
              />
            </div>
          </div>
        </div>

        <div class="mb-2 color-orange-validation" v-if="FBM.validation.productsForCellArray">
          {{ $t(`${FBM.validationTranslate.productsForCellArray}.localization_value.value`) }}
        </div>

        <div class="fragment"
             v-if="initialOptionsProducts.length > 0"
             v-bind:class="{'loading-products': productLoading}"
        >
          <SelectProductBlock
              v-for="(item, index) in productsForCellArray"
              :autoloadSelect="true"
              :initialOptionsProducts="initialOptionsProducts"
              :key="index+'product'"
              :item="item.data.Product"
              :userId="parseInt(user.userId)"
              :productLabel="'name_for_fbm'"
              :price="!checkSelectedUSACountry"
              :description="!checkSelectedUSACountry"
              :hsCode="!checkSelectedUSACountry"
              :disabled="isDisabledCustomization(item.data.Product) || isUseCustomizationAndEdit"
              :disabledAllFields="isDisabledCustomization(item.data.Product) || isUseCustomizationAndEdit"
              @removeProduct="removeProduct(productsForCellArray, index)"
              @changeProductName="changeProductName"
              @changeProductQuantity="changeProductQuantity"
          />
        </div>

        <div class="order-create__product-btn add-product-btn-wrap"
             v-bind:class="{
                'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate(),
                'disabled-btn': isUseCustomizationAndEdit
              }">
          <div class="admin-edit" @click="editTranslate(['common_AddProduct',])"></div>
          <span class="order-create__product-btn-i add-product-btn site-link"
                @click="FBM.addProductForCells()">
					+ {{$t('common_AddProduct.localization_value.value')}}
					</span>
        </div>
      </template>
      <template v-else>
        <div class="mb-4">
          <MainButton
              class="wfc"
              :value="'+ ' + $t('common_AddProduct.localization_value.value')"
              @click.native="showOrAddProduct()"
          />
        </div>
      </template>
    </template>



    <div class="mb-3" v-if="isWarehouse && !FBM.data.isUserLabel">
      <div class="order-create__section-label section-label"
           v-bind:class="{'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}">
        <div class="admin-edit" @click="editTranslate(['fbm_Packaging'])"></div>
        {{$t('fbm_Packaging.localization_value.value')}}
      </div>

      <Packaging
          :FBM="FBM"
      />
    </div>

    <template v-if="isWarehouse">
      <div v-show="!isNoAdditionalPackaging">
        <GiftMassage
            class="mt-4"
            :FBM="FBM"
            :giftPapers="giftPapers"
        />

        <div class="order-create__section-label section-label"
             v-bind:class="{'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}">
          <div class="admin-edit" @click="editTranslate(['fbm_giftPackaging'])"></div>
          {{$t('fbm_giftPackaging.localization_value.value')}}
        </div>

        <GiftPackaging
            :FBM="FBM"
        />
      </div>
    </template>

    <div class="order-create__section-label section-label"
         v-if="!isWarehouse"
         v-bind:class="{'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}">
      <div class="admin-edit" @click="editTranslate(['fbm_Dimentions'])"></div>
      {{$t('fbm_Dimentions.localization_value.value')}}
    </div>

    <div class="custom-row" v-if="isWarehouse">
      <div class="custom-col custom-col--66 custom-col--sm-100"
           v-bind:class="{'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}">
        <div class="admin-edit" @click="editTranslate(['fbm_DimensionsOuterWarning'])"></div>
        <WarningStatic class="mw-100 w-100" :type="'yellow'">
          <template slot="text">
            {{$t('fbm_DimensionsOuterWarning.localization_value.value')}}
          </template>
        </WarningStatic>
      </div>
    </div>

    <Dimensions
            :FBM="FBM"
            :dimensions="FBM.data.Dimensions"
            :onlyKg="true"
            :canDimensionsDots="isLabel || isConsolidation"
            @dimensionsChanged="getShippingFunc(); FBM.data.optionalForDimensionsChangesCount++"
    />

    <EngravingFile
        v-if="isWarehouse && !isWarehouseCambridge"
        :FBM="FBM"
    />

    <!--<LotNumberBlock-->
            <!--:FBM="FBM"-->
    <!--/>-->




<!--    <AddToProfilePopup-->
<!--            @close="closeAddToProfilePopup"-->
<!--            v-if="isModalAddToProfilePopup"-->
<!--    />-->

<!--    <DeleteProductPopup-->
<!--            @close="closeDeleteProductPopup"-->
<!--            v-if="isModalDeleteProductPopup"-->
<!--    />-->

  </div>
</template>

<script>
  // import DefaultSelect from "../../../../../../UI/selectiones/DefaultSelect/DefaultSelect";
  // import AddToProfileIco from '../../../../../../../../public/img/UI-group/add-to-profile-ico.svg?inline'
  import TitleHorizontal from "../../../../../../coreComponents/TitleHorizontal/TitleHorizontal";
  // import InputQuantity from "../../../../../../UI/inputs/InputQuantity/InputQuantity";
  // import InputSum from "../../../../../../UI/inputs/InputSum/InputSum";
  import {VPopover} from "v-tooltip";
  // import DefaultCheckbox from "../../../../../../UI/checkboxes/DefaultCheckbox/DefaultCheckbox";
  import TooltipBtn from "../../../../../../UI/tooltips/TooltipBtn/TooltipBtn";
  // import DeleteProductBtn from "../../../../../../coreComponents/DeleteProductBtn/DeleteProductBtn";
  // import AddToProfilePopup from "../../../../popups/AddToProfilePopup/AddToProfilePopup";
  // import DeleteProductPopup from "../../../../popups/_DeleteProductPopup/DeleteProductPopup";
  import {mixinDetictingMobile} from "../../../../../../../mixins/mobileFunctions";
  import ProductItemCreation from "../../../../../../coreComponents/ProductItemCreation/ProductItemCreation";
  import SelectProductBlock from "../../../../../../coreComponents/SelectProductBlock/SelectProductBlock";
  import {CAMBRIDGE_WAREHOUSE, FBM_ORDER_TYPES} from "../../../../../../../staticData/staticVariables";
  import {
    FBMGiftPackagingMixin,
    FBMMixinsHelper,
    FBMProductMixin
  } from "../../../../../../../mixins/FBMMixins/FBMMixins";
  import Dimensions from "../../chunks/Dimensions/Dimensions";
  // import LotNumberBlock from "../../chunks/LotNumberBlock/LotNumberBlock";
  import {FBMMixins} from "../../../../../../../mixins/FBMMixins/FBMMixins";
  import RadioDefault from "@/components/UI/radiobuttons/RadioDefault/RadioDefault";
  import MainButton from "../../../../../../UI/buttons/MainButton/MainButton";
  import EngravingFile
    from "@/components/modules/OrdersFBMModule/components/components/chunks/EngravingFile/EngravingFile";
  import Packaging
    from "@/components/modules/OrdersFBMModule/components/components/FBMUserBlocks/StepThree/Packaging/Packaging";
  import GiftMassage
    from "@/components/modules/OrdersFBMModule/components/components/FBMUserBlocks/StepThree/GiftMassage/GiftMassage";
  import GiftPackaging
    from "@/components/modules/OrdersFBMModule/components/components/FBMUserBlocks/StepThree/GiftPackaging/GiftPackaging";
  import WarningStatic from "@/components/UI/alerts/WarningStatic/WarningStatic";

  export default {
    name: "StepTwo",

    components: {
      WarningStatic,
      Packaging,
      GiftMassage,
      GiftPackaging,
      EngravingFile,
      RadioDefault,
      MainButton,
      // LotNumberBlock,
      Dimensions,
      SelectProductBlock,
      // DefaultSelect,
      TitleHorizontal,
      // AddToProfileIco,
      // InputQuantity,
      // InputSum,
      VPopover,
      // DefaultCheckbox,
      TooltipBtn,
      // DeleteProductBtn,
      // AddToProfilePopup,
      // DeleteProductPopup,
      ProductItemCreation,
    },

    mixins: [mixinDetictingMobile, FBMMixinsHelper, FBMProductMixin, FBMMixins, FBMGiftPackagingMixin],

    props: {
      FBM: Object,
      user: Object,
      proformProducts: Array,
      productsForCellArray: Array,
      isEdit: {
        type: Boolean,
        default: true
      },
    },

    watch: {
      productsForCellArray: {
        handler: function() {
          this.checkHideProductsFromWarehouse()
        },
        deep: true
      },

      selectedCountry() {
        this.getWarehouseStorage()
      },
    },


    computed: {},

    data() {
      return {
        options: [{}],

        FBM_ORDER_TYPES: FBM_ORDER_TYPES,

        tooltipAddProductActive: true,

        serverError: false,

        initialOptionsProducts: [],
        productLoading: false,

        warehouses: [],
        showProducts: false,
        CAMBRIDGE_WAREHOUSE: CAMBRIDGE_WAREHOUSE,

        giftPapers: [],
      }
    },

    mounted() {
      this.getWarehouseStorage()
      this.checkHideProductsFromWarehouse()

      this.$store.dispatch('fetchPackagingGiftPapers', '?filter[enable]=1&page=0&limit=100000').then(response => {
        this.giftPapers = this.getRespPaginateData(response)
      })
    },

    methods: {

      changeValueQuantity(item, val) {
        // console.log(data);
        item.setProductCount(val)
      },


      changeValueSum(data) {
        this.valueSum = data
      },


      getShippingFunc() {

        if (this.currentPersonalContactName && this.selectedCountry && !this.FBM.data.useEasyPost && !this.isLabel && this.isSetWarehouse) {
          if(
              (Number(this.FBM.data.Dimensions.data.weightLB) > 0 || Number(this.FBM.data.Dimensions.data.weightOZ) > 0) &&
              Number(this.FBM.data.Dimensions.data.height) > 0 &&
              Number(this.FBM.data.Dimensions.data.width) > 0 &&
              Number(this.FBM.data.Dimensions.data.dimensionLength) > 0
          ) {
            this.getShippingData()
          }
        }

        if(
            (!this.FBM.data.Dimensions.data.weightLB || Number(this.FBM.data.Dimensions.data.weightLB) <= 0) &&
            (!this.FBM.data.Dimensions.data.weightOZ || Number(this.FBM.data.Dimensions.data.weightOZ) <= 0))
          return

        if(
          !(
            (Number(this.FBM.data.Dimensions.data.weightLB) > 0 || Number(this.FBM.data.Dimensions.data.weightOZ) > 0) &&
            Number(this.FBM.data.Dimensions.data.height) > 0 &&
            Number(this.FBM.data.Dimensions.data.width) > 0 &&
            Number(this.FBM.data.Dimensions.data.dimensionLength) > 0
          )
        ) return

        if (this.currentPersonalContactName && this.selectedCountry
            //&& (this.FBM.data.useEasyPost || this.isLabel)
            && this.isSetWarehouse)
        {
          this.getShippingData().then(() => {
            if(this.FBM.data.popularMethodsType) {
              this.getPopularMethods()
            } else {
              this.getShippingPrices()
            }
            // this.getShippingPrices().then(() => {
            // })
          })
        }
      },

      showOrAddProduct() {
        if (this.productsForCellArray.length === 0) {
          this.FBM.addProductForCells()
        }
        this.showProducts = true
      },

      checkHideProductsFromWarehouse() {
        if ((this.productsForCellArray.length > 0 && this.productsForCellArray[0]?.data?.Product?.product?.id && !this.showProducts) || !this.isConsolidation) {
          this.showProducts = true
        }
      }
    },
  }
</script>

<style scoped>
.width-initial{
  width: initial;
}
.loading-products{
  opacity: 0.5;
  pointer-events: none;
}
</style>
